// extracted by mini-css-extract-plugin
module.exports = {"offers":"HelpOffersModal_offers__2r8Fi","checkboxHelpOffers":"HelpOffersModal_checkboxHelpOffers__2mB2e"};